import {handleValidationCheck} from "../validation/Validation";
import {renderDropdownFieldFromDBList,renderInputTextField } from '../models/FormTemplate';
import {jobIndustry,systemConfiguration,Endpoint, Properties,getDecryptedValueByProperty,getHeaders,postOperation,handleEncode } from "../../CommonImports";
import {useState,useEffect } from '../../InBuildImports';



const GJobPost = () => {
      const token = getDecryptedValueByProperty(Properties.SESSION_TOKEN_PROP);
      const studentId = getDecryptedValueByProperty(Properties.STUDENT_ID_PROP);
      const [errorsJson, setErrorsJson] = useState({});
    

  const handleValidate = (e) => {
      const { name, value } = e.target;
      //let isValid = false;
      const res = handleValidationCheck(e,setErrorsJson);   
      console.log("field name::"+name);
      console.log("ErrorResponseJSON", res);
      return res;
  };

    const jobIndustryData = jobIndustry.map((obj) => {
        return obj.value;
      });

  useEffect(() => {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
        link.id = "myclass-bootstrap";
        document.head.appendChild(link);
        return () => {
            document.head.removeChild(link);
        };
    }, []);

 const [file, setFile] = useState(null);
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        
    };
    const Header_Json=getHeaders(token,handleEncode(studentId))
    const [formData, setFormData] = useState({
        id: "",
        companyJobId: "",
        companyName:"",
        jobPosterPersonName: "",
        jobPosterEmailId: "",
        jobIndustry: "",
        jobType: "",
        workMode: "",
        jobLocationCity: "",
        emailId: "",
        phoneNo: "",
        skills: "",
        role: "",
        jobDescription: "",
        jobResponsibilities: "",
        budget: "",
        candidateIdFromUploadResume: [],
        requiredExperience: 0,
        companyLogoUrl: "",
        qualification : "",
        noOfVacancy: "",
        creationDate:"",
        lastModifiedDate: ""
      });
     
      const handleImageChange = (e) => {
          setFile(e.target.files[0]);
      }
      const handleSubmit = async (e) => {
        const newformData = new FormData();
        e.preventDefault();
        const formPayload = {
                ...formData
              };
          
            newformData.append('data', JSON.stringify(formPayload));
            newformData.append('file', file);
              
            const url=`${systemConfiguration.HOST}${Endpoint.UPLOAD_JOB_POST}`
                const response = await postOperation(
                  url,
                  newformData ,Header_Json);        
            }
      
           

    return (
        <div>
           <section class="vh-100 gradient-custom">
  <div  class="container py-5 h-100">
    <div class="row justify-content-left align-items-left h-100">
      <div class="col-12 col-lg-9 col-xl-7">
        <div class="card shadow-2-strong card-registration" style={{borderRadius: "15px"}}>
          <div class="card-body p-4 p-md-5">
            <h3 class="mb-4 pb-2 pb-md-0 mb-md-5">Post Job</h3>
            <form onSubmit={handleSubmit}>
            

              <div class="row">
                <div class="col-md-3 mb-4">

                  <div data-mdb-input-init class="form-outline">

                  {renderInputTextField('companyJobId', 'Job Id','companyJobId',formData.companyJobId,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
                    <label class="form-label" for="companyJobId">Job Id</label>
                  </div>

                </div>
				<div class="col-md-4 mb-4">

                  <div data-mdb-input-init class="form-outline">
                  {renderInputTextField('companyName', 'companyName','Company Name',formData.companyName,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
                    <label class="form-label" for="companyName">company Name</label>
                  </div>

                </div>
				
                <div class="col-md-4 mb-4">

                  <div data-mdb-input-init class="form-outline">
                  {renderInputTextField('jobLocationCity', 'jobLocationCity','jobLocationCity',formData.jobLocationCity,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
                    <label class="form-label" for="jobLocationCity">Job Location</label>
                  </div>

                </div>
              </div>
			 <div class="row">
							<div class="col-md-3 mb-4">

							  <div data-mdb-input-init class="form-outline">
                              {renderInputTextField('emailId', 'emailId','Email',formData.emailId,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="emailId">Email</label>
							  </div>

							</div>
							<div class="col-md-4 mb-4">

							  <div data-mdb-input-init class="form-outline">
                              {renderInputTextField('phoneNo', 'phoneNo','Phone',formData.phoneNo,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="phoneNo">Phone Number</label>
							  </div>

							</div>
							
							<div class="col-md-4 mb-4">
							{renderInputTextField('role', 'role','Role',formData.role,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
						<label class="form-label" for="role">Job Title</label>
							</div>
						  </div>
			<div class="row">
                <div class="col-md-3 mb-4">

                  <div data-mdb-input-init class="form-outline">
                  { renderDropdownFieldFromDBList('jobIndustry','jobIndustry',formData.jobIndustry,jobIndustryData,handleChange,(e) => { handleValidate(e) },errorsJson)}
                            
                   {/* <select data-mdb-select-init>
								<option value="0">Select</option>
								<option value="1">IT Software / Hardware /Networking</option>
								<option value="2">Education</option>
								<option value="3">Non-IT</option>
								<option value="4">BPO</option>
								<option value="4">Real Estate</option>
								<option value="4">Transport</option>
							</select> */}
                    <label class="form-label" for="jobIndustry">job Industry</label>
                  </div>

                </div>
				<div class="col-md-4 mb-4">

                  <div data-mdb-input-init class="form-outline">
                    <select data-mdb-select-init>
								<option value="0">Select</option>
								<option value="1">Fulltime</option>
								<option value="2">Contract</option>
								<option value="3">Contract-To-Hire</option>
								<option value="4">Freelancers</option>
								<option value="4">PartTime</option>
							</select>
                    <label class="form-label" for="firstName">job Type</label>
                  </div>

                </div>
				
                <div class="col-md-4 mb-4">

                  <div data-mdb-input-init class="form-outline">
                   <select data-mdb-select-init>
								<option value="0">Select</option>
								<option value="1">Office</option>
								<option value="2">Hybrid</option>
								<option value="3">Remote</option>
								<option value="4">Client-Side</option>
							</select>
                    <label class="form-label" for="lastName">Work Mode</label>
                  </div>

                </div>
              </div>
			  
			   <div class="row">
							<div class="col-md-3 mb-4">

							  <div data-mdb-input-init class="form-outline">
                      {renderInputTextField('budget', 'budget','Budget',formData.budget,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="budget">Salary Budget</label>
							  </div>

							</div>
							<div class="col-md-4 mb-4">
							  <div data-mdb-input-init class="form-outline">
                  {renderInputTextField('skills', 'skills','skills',formData.skills,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="skills">Skills</label>
							  </div>
							</div>
						  </div>
						  
			   <div class="row">
							<div class="col-md-3 mb-4">
							  <div data-mdb-input-init class="form-outline">
                        {renderInputTextField('requiredExperience', 'requiredExperience','requiredExperience',formData.requiredExperience,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="requiredExperience">Experience</label>
							  </div>
							</div>
							
							<div class="col-md-3 mb-4">
							  <div data-mdb-input-init class="form-outline">
                    {renderInputTextField('qualification', 'qualification','qualification',formData.qualification,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="qualification">Qualification</label>
							  </div>
							</div>
							
						<div class="col-md-3 mb-4">
							  <div data-mdb-input-init class="form-outline">
                       {renderInputTextField('noOfVacancy', 'noOfVacancy','noOfVacancy',formData.noOfVacancy,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
								<label class="form-label" for="noOfVacancy">No Of Vacancy</label>
							  </div>
							</div>
             </div>
             

              <div class="row">
                <div class="col-md-6 mb-4 pb-2">

                  <div data-mdb-input-init class="form-outline">
                 {renderInputTextField('jobPosterPersonName', 'jobPosterPersonName','jobPosterPersonName',formData.jobPosterPersonName,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
                    <label class="form-label" for="jobPosterPersonName">Job Poster PersonName</label>
                  </div>

                </div>
                <div class="col-md-6 mb-4 pb-2">

                  <div data-mdb-input-init class="form-outline">
                  {renderInputTextField('jobPosterEmailId', 'jobPosterEmailId','jobPosterEmailId',formData.jobPosterEmailId,null,handleChange,(e) => { handleValidate(e) },errorsJson)}
             
                    <label class="form-label" for="jobPosterEmailId">Job Poster Email Id</label>
                  </div>

                </div>
              </div>

			<div class="row">
                <div class="col-md-6 mb-4 pb-2">

                  <div data-mdb-input-init class="form-outline">
				  <textarea class="form-control" rows="3" id="Job Description" placeholder="Job Description"></textarea>
                    <label class="form-label" for="phoneNumber">Job Description</label>
                  </div>

                </div>
                <div class="col-md-6 mb-4 pb-2">

                  <div data-mdb-input-init class="form-outline">
				  <textarea class="form-control" rows="3" id="JobResponsibilities" placeholder="Job Responsibilities"></textarea>
                    <label class="form-label" for="phoneNumber">Job Responsibilities</label>
                  </div>

                </div>
              </div>
              <input
              name="uploadCompayLogoUrl"
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="GStudentProfile-mt-3"
            />
              <div class="mt-4 pt-2">
                <input data-mdb-ripple-init class="btn btn-primary btn-lg" type="submit" value="Submit" />
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        </div>
    );

}
export default GJobPost;